/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React, { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";

/**
 * Desktop page header shared by every tab: title, a one-line summary and the
 * page's actions. Phones show the title in the top bar instead, so it hides there.
 */
export const PageHeader: React.FC<{
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}> = ({ title, subtitle, actions }) => {
  // The desktop shell owns a top row shared with the clock; render into it.
  const slot = useSyncExternalStore(
    () => () => {},
    () => document.getElementById("page-head-slot"),
    () => null,
  );

  const header = (
    <header className="page-head">
      <div className="page-head-txt">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="page-head-act">{actions}</div>}
    </header>
  );
  return slot ? createPortal(header, slot) : header;
};
